import { useLocation } from "react-router-dom";

const SECTION_LABELS = {
  "/panel_customer": "Overview",
  "/panel_customer/bookride": "Book a Ride",
  "/panel_customer/booking": "My Bookings",
  "/panel_customer/profile": "Profile",
};

export default function Header({ onToggleSidebar }) {
  const { pathname } = useLocation();
  const currentLabel = SECTION_LABELS[pathname] || "Overview";
  return (
    <>
      <header className="dash-header">
        <button
          type="button"
          className="hamburger-btn"
          id="hamburgerBtn"
          aria-label="Open menu"
          onClick={onToggleSidebar}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="breadcrumb">
          <span>My Rides</span> /{" "}
          <strong id="breadcrumbCurrent">{currentLabel}</strong>
        </div>
        <div className="header-actions">
          <button className="icon-btn" aria-label="Notifications">
            🔔
            <span className="notif-dot" />
          </button>
          <div className="header-user">
            <span className="user-chip-avatar">🙂</span>
            <span className="user-chip-info">
              <span className="user-chip-name" id="custName">
                Demo Customer
              </span>
              <span className="user-chip-role">Customer</span>
            </span>
          </div>
        </div>
      </header>
    </>
  );
}
